export const PAST_DUE_INVOICE_COUNTRIES = ['US', 'CA']

// Single switch for every past-due-invoice gate (upgrade-order.js,
// AccountSetup/index.js, AllAccounts/index.js, MyAccounts/index.js,
// EmailLookup/index.js): true renders the InvoiceInformation component
// (lets the rep see/resolve the invoice inline), false restores the original
// static blocking Modal. Flip this one value to go back — no per-file changes
// needed.
export const SHOW_INVOICE_INFO_FOR_PAST_DUE = true

export async function hasBlockingPastDueInvoice(client, thryvId, country) {
  if (!PAST_DUE_INVOICE_COUNTRIES.includes(country)) return false
  try {
    const {openInvoices} = await client(`invoices/${thryvId}`)
    const hasPastDueInvoices = openInvoices?.some(
      invoice => invoice.state === 'past_due',
    )
    if (hasPastDueInvoices) {
      return true
    }
    return false
  } catch (e) {
    console.error('Error checking past due invoice status', e)
    return false
  }
}
